import { rest } from "msw";
import { apiUrl } from "features/configure";
const responses = [
  [{ type: "content", content: `yoyoyo` }],
  [{ type: "content", content: `Talk about your problem` }],
  [
    {
      type: "content",
      data: "用戶分析透過鏈上數據，幫您整理出以下地址，這些地址同時持有所有與tag相關token，是最有可能對您的產品有興趣的audience，以下是他們鏈上輪廓報告。",
    },
    { type: "tags", data: ["DOGE", "SHIB"] },
    {
      type: "graphs",
      data: [
        { graph_type: "count", data: { label: "address count", value: 5514 } },
        {
          graph_type: "count",
          data: { label: "wallet value", value: 2345514 },
        },
        {
          graph_type: "piechart", // 長條圖 某某格子圖
          data: [
            { label: "BTC", value: "24.15%" },
            { label: "ETH", value: "20.73%" },
          ],
        },
      ],
    },
    {
      type: "content",
      data: "這些關鍵字將幫助您，更好地理解相關的趨勢，如果不滿意，您可以選擇'Renewed'重新產生，或是提供更進一步的資訊，讓我更貼近您的需求",
    },
  ],
  [{ type: "result", data: { id: "23r2y024joe" } }],
];

let currentIndex = 0;

const getGreeting = rest.get(`${apiUrl}/api/adam/greeting`, (req, res, ctx) => {
  return res(
    ctx.status(200),
    ctx.json([{ type: "content", content: `Hello world` }])
  );
});

const getResponse = rest.post(
  `${apiUrl}/api/adam/response`,
  (req, res, ctx) => {
    const response = responses[currentIndex];
    currentIndex = currentIndex + 1;
    return res(ctx.status(200), ctx.json(response));
  }
);

const getAiSupport = rest.get(
  `${apiUrl}/api/manage/aiSupport/:entityName`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        enabled: true,
        connected: true,
        tone: "Formal",
        responseLength: "Short",
        responseLanguage: "Auto Detect",
        fallbackMessage:
          "This question is best handled by a human agent. Do you want to connect to a human agent?",
        magicWand: {
          connected: true,
          updatedAt: "2025-05-16T10:25:03.116Z",
          createdAt: "2025-05-16T10:25:03.116Z",
        },
        updatedAt: "2025-05-16T10:25:03.116Z",
        createdAt: "2025-05-16T10:25:03.116Z",
        widgetVersionCheck: true,
        knowledgeBaseResourceCount: 10,
      })
    );
  }
);

const startTestGroundChat = rest.post(
  `${apiUrl}/api/widget/:entityName/startTestGroundChat`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        _id: "682d9b9ee3a4af454ed31cf7",
        isSurveySent: false,
        type: "Other",
        status: "New",
        title: "Test Ground Chat for standard",
        messages: {
          count: 4,
          hasNext: false,
          hasPrevious: false,
          results: [
            {
              _id: "682d9b9ee3a4af454ed31cff",
              imagesUrl: [],
              isSystemMessage: false,
              data: [],
              vectorIds: [],
              message: "Hi! How can I assist you today?",
              isAdminResponse: true,
              created: "2025-05-21T09:23:42.692Z",
              role: "assistant",
              sources: [],
              isFirst: true,
            },
            {
              _id: "682d9b9ee3a4af454ed31d02",
              imagesUrl: [],
              isSystemMessage: false,
              data: [
                {
                  text: "General",
                },
                {
                  text: "Bug Report",
                },
                {
                  text: "下面一位～",
                },
                {
                  text: "Partners",
                },
                {
                  text: "Wombat - question",
                },
                {
                  text: "Johnnytest",
                },
                {
                  text: "Other",
                },
              ],
              vectorIds: [],
              message: "Please select a ticket type",
              isAdminResponse: false,
              created: "2025-05-21T09:23:43.692Z",
              role: "button",
              sources: [],
            },
            {
              _id: "682d9ba6e3a4af454ed31dad",
              imagesUrl: [],
              isSystemMessage: false,
              data: [],
              vectorIds: [],
              message:
                "How can I bridge assets between IoTeX and other blockchains?",
              isAdminResponse: false,
              created: "2025-05-21T09:23:50.089Z",
              role: "user",
              sources: [],
            },
            {
              _id: "682d9ba9e3a4af454ed31de2",
              imagesUrl: [],
              isSystemMessage: false,
              data: [],
              vectorIds: [],
              message:
                "You can use the ioTube Bridge to transfer assets between IoTeX and supported blockchains like Ethereum and BNB Chain. Please visit https://bridge.iotex.io/ for detailed instructions and to ensure proper token formats during the bridging process.",
              isAdminResponse: true,
              created: "2025-05-21T09:23:50.089Z",
              role: "assistant",
              sources: [
                {
                  _id: "682d9ba9e3a4af454ed31de3",
                  title: "Refined Response",
                  url: "How can I bridge assets between IoTeX and other blockchains?",
                  content:
                    "User Question: How can I bridge assets between IoTeX and other blockchains? Answer: The ioTube Bridge allows users to transfer assets between IoTeX and supported blockchains like Ethereum and BNB Chai...",
                },
                {
                  _id: "682d9ba9e3a4af454ed31de4",
                  title: "Refined Response",
                  url: "iotex 的 rpc endpoint 有哪些",
                  content:
                    "User Question: iotex 的 rpc endpoint 有哪些 Answer: These endpoints can be used to connect wallets and development tools to the IoTeX network.\n\t•\tMainnet RPC: https://babel-api.mainnet.iotex.io\n\t•\tTestnet...",
                },
                {
                  _id: "682d9ba9e3a4af454ed31de5",
                  title: "https://beraborrow.gitbook.io/docs",
                  url: "https://beraborrow.gitbook.io/docs",
                  content:
                    "or DEX aggregator, such as ooga booga () to swap assets into the target tokens of interest. For instance, a user might want to swap some BERA to a mixture of HONEY and USDC:BEX pools can be found here...",
                },
                {
                  _id: "682d9ba9e3a4af454ed31de6",
                  title: "https://beraborrow.gitbook.io/docs",
                  url: "https://beraborrow.gitbook.io/docs",
                  content:
                    'a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0...',
                },
                {
                  _id: "682d9ba9e3a4af454ed31de7",
                  title: "https://beraborrow.gitbook.io/docs",
                  url: "https://beraborrow.gitbook.io/docs",
                  content:
                    "to increase exposure, users can achieve leverage using a flash loan.For example, Alice starts with $100 worth of collateral and wants 5x exposure. She flashloans $500 worth of the collateral and depos...",
                },
              ],
              aiRespondsTo: "682d9ba6e3a4af454ed31dad",
            },
          ],
        },
        entity: {
          name: "standard",
          company: {
            name: "Standard CRM",
            logo: "https://storage.googleapis.com/metadesk-dev/logo/standard/StaderLogo_Dark(3)_1693164530128-1715629192.png",
            website: "test.com",
          },
        },
      })
    );
  }
);
const getMessages = rest.get(
  `${apiUrl}/api/trainingArea/:entityName/messages`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        hasUntrainedFeedback: false,
        messages: [
          {
            _id: "682d9b6ce3a4af454ed31ab5",
            vectorIds: ["msg_682d9b6ce3a4af454ed31ab5_chunk_0"],
            testGround: "682d9ad4e3a4af454ed3107d",
            created: "2025-05-21T09:22:47.564Z",
            adminFeedback: "thumbDown",
            adminFeedbackBy: {
              _id: "67bd4150db2141163874bebd",
              address: "0xB6DbF7cD5b1548E1a2ADeB8B62BC7f48486f67AF",
              name: "Philo",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2025-02-25T04:04:32.890Z",
              __v: 0,
              latestLogin: "2025-06-04T07:06:15.888Z",
              email: "philo.huang@metacrm.inc",
              readonly: false,
            },
            adminFeedbackCreated: "2025-05-21T09:22:56.987Z",
            improvedResponse:
              "The ioTube Bridge allows users to transfer assets between IoTeX and supported blockchains like Ethereum and BNB Chain. Ensure you’re using the correct token formats and follow the bridge instructions carefully.\nhttps://bridge.iotex.io/",
            userInput:
              "How can I bridge assets between IoTeX and other blockchains?",
            originalResponse:
              "這個問題超出了我提供的資料範圍，建議您聯繫人工客服以獲取更詳細的協助。您是否需要我協助連接人工客服？",
          },
          {
            _id: "682d9b38e3a4af454ed31947",
            vectorIds: ["msg_682d9b38e3a4af454ed31947_chunk_0"],
            testGround: "682d9ad4e3a4af454ed3107d",
            created: "2025-05-21T09:21:57.236Z",
            adminFeedback: "thumbDown",
            adminFeedbackBy: {
              _id: "67bd4150db2141163874bebd",
              address: "0xB6DbF7cD5b1548E1a2ADeB8B62BC7f48486f67AF",
              name: "Philo",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2025-02-25T04:04:32.890Z",
              __v: 0,
              latestLogin: "2025-06-04T07:06:15.888Z",
              email: "philo.huang@metacrm.inc",
              readonly: false,
            },
            adminFeedbackCreated: "2025-05-21T09:22:04.560Z",
            improvedResponse:
              "These endpoints can be used to connect wallets and development tools to the IoTeX network.\n\t•\tMainnet RPC: https://babel-api.mainnet.iotex.io\n\t•\tTestnet RPC: https://babel-api.testnet.iotex.io",
            userInput: "iotex 的 rpc endpoint 有哪些",
            originalResponse:
              "抱歉，根據提供的資料，沒有提及 IOTEX 的 RPC 端點資訊。這個問題最好由人工客服來處理。您是否需要我協助連接人工客服？",
          },
          {
            _id: "680f62df808bf3d03ba9da37",
            vectorIds: ["msg_680f62df808bf3d03ba9da37_chunk_0"],
            ticket: "680f62d0808bf3d03ba9d9ae",
            created: "2025-04-28T11:13:35.248Z",
            userFeedback: "thumbDown",
            userFeedbackCreated: "2025-04-29T08:57:09.014Z",
            improvedResponse: "testtest",
            userInput: "hi",
            originalResponse:
              "Hello, I am xgdsdfhsdjkflhdfghdfgdhjdgklfdfghjkdlfjglhkdjfklgjhkldfjgh. How can I assist you today?",
          },
          {
            _id: "680f1dadead1f996d55dbbcc",
            vectorIds: [],
            testGround: "680f1d76ead1f996d55dba03",
            created: "2025-04-28T06:18:17.554Z",
            adminFeedback: "thumbDown",
            adminFeedbackBy: {
              _id: "67bd4150db2141163874bebd",
              address: "0xB6DbF7cD5b1548E1a2ADeB8B62BC7f48486f67AF",
              name: "Philo",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2025-02-25T04:04:32.890Z",
              __v: 0,
              latestLogin: "2025-06-04T07:06:15.888Z",
              email: "philo.huang@metacrm.inc",
              readonly: false,
            },
            adminFeedbackCreated: "2025-04-28T07:36:10.863Z",
            userInput: "454",
            originalResponse:
              "This question is best handled by a human agent. Do you want to connect to a human agent?",
          },
          {
            _id: "680f1d79ead1f996d55dba3d",
            vectorIds: [],
            testGround: "680f1d76ead1f996d55dba03",
            created: "2025-04-28T06:17:29.520Z",
            adminFeedback: "thumbDown",
            adminFeedbackBy: {
              _id: "675664b9bdf1562c97acecc2",
              address: "0x2443B2e5953E09710496ac4ec69309aAD6060E46",
              name: "KY",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2024-12-09T03:32:09.070Z",
              __v: 0,
              latestLogin: "2025-06-04T07:05:16.319Z",
              email: "kyyao@metacrm.inc",
              telegram: "",
            },
            adminFeedbackCreated: "2025-04-28T06:18:26.903Z",
            userInput: "General",
            originalResponse:
              "Got it! Could you share a bit more detail so I can assist you better?",
          },
          {
            _id: "680f1483ead1f996d55d7c6d",
            vectorIds: ["msg_680f1483ead1f996d55d7c6d_chunk_0"],
            ticket: "680f1477ead1f996d55d7bd7",
            created: "2025-04-28T05:39:15.700Z",
            adminFeedback: "thumbDown",
            adminFeedbackBy: {
              _id: "66b98702617b43f4c126fc07",
              address: "0x44dE5FDAFa32dA99DBA2561f7b3E67543224a0e7",
              name: "ning",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2024-08-12T03:52:34.736Z",
              __v: 0,
              latestLogin: "2025-05-29T02:58:27.355Z",
            },
            adminFeedbackCreated: "2025-04-28T07:14:19.586Z",
            improvedResponse: "hellothisisatestmsg",
            userInput: "gg",
            originalResponse:
              "This question is best handled by a human agent. Do you want to connect to a human agent?",
          },
          {
            _id: "680f000bead1f996d55ce354",
            vectorIds: ["msg_680f000bead1f996d55ce354_chunk_0"],
            testGround: "6808957f98df9db058acadb4",
            created: "2025-04-28T04:11:50.743Z",
            adminFeedback: "thumbDown",
            adminFeedbackBy: {
              _id: "675664b9bdf1562c97acecc2",
              address: "0x2443B2e5953E09710496ac4ec69309aAD6060E46",
              name: "KY",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2024-12-09T03:32:09.070Z",
              __v: 0,
              latestLogin: "2025-06-04T07:05:16.319Z",
              email: "kyyao@metacrm.inc",
              telegram: "",
            },
            adminFeedbackCreated: "2025-04-28T04:12:00.434Z",
            improvedResponse: "123",
            userInput: "123",
            originalResponse:
              "This question is best handled by a human agent. Do you want to connect to a human agent?",
          },
          {
            _id: "680efe91ead1f996d55ccbae",
            vectorIds: [],
            testGround: "6808957f98df9db058acadb4",
            created: "2025-04-28T04:05:32.347Z",
            adminFeedback: "thumbDown",
            adminFeedbackBy: {
              _id: "675664b9bdf1562c97acecc2",
              address: "0x2443B2e5953E09710496ac4ec69309aAD6060E46",
              name: "KY",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2024-12-09T03:32:09.070Z",
              __v: 0,
              latestLogin: "2025-06-04T07:05:16.319Z",
              email: "kyyao@metacrm.inc",
              telegram: "",
            },
            adminFeedbackCreated: "2025-04-28T06:18:20.283Z",
            userInput: "j",
            originalResponse:
              "This question is best handled by a human agent. Do you want to connect to a human agent?",
          },
          {
            _id: "68089b3a98df9db058acd57a",
            vectorIds: ["msg_68089b3a98df9db058acd57a_chunk_0"],
            ticket: "68089af498df9db058acd3da",
            created: "2025-04-23T07:48:10.270Z",
            userFeedback: "thumbDown",
            adminFeedback: "thumbDown",
            improvedResponse: "hhh",
            adminFeedbackBy: {
              _id: "67bd4150db2141163874bebd",
              address: "0xB6DbF7cD5b1548E1a2ADeB8B62BC7f48486f67AF",
              name: "Philo",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2025-02-25T04:04:32.890Z",
              __v: 0,
              latestLogin: "2025-06-04T07:06:15.888Z",
              email: "philo.huang@metacrm.inc",
              readonly: false,
            },
            adminFeedbackCreated: "2025-04-28T04:06:19.909Z",
            userInput: "How's the weather today?",
            originalResponse:
              "根據提供的資訊，天氣相關的詳細情況未提及。請您參考天氣應用程式或相關網站獲取最新天氣資訊。",
          },
          {
            _id: "68089aa398df9db058acd28d",
            vectorIds: [],
            testGround: "6808957f98df9db058acadb4",
            created: "2025-04-23T07:45:35.197Z",
            adminFeedback: "thumbDown",
            improvedResponse: null,
            adminFeedbackBy: {
              _id: "67bd4150db2141163874bebd",
              address: "0xB6DbF7cD5b1548E1a2ADeB8B62BC7f48486f67AF",
              name: "Philo",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2025-02-25T04:04:32.890Z",
              __v: 0,
              latestLogin: "2025-06-04T07:06:15.888Z",
              email: "philo.huang@metacrm.inc",
              readonly: false,
            },
            adminFeedbackCreated: "2025-04-28T07:36:04.868Z",
            userInput: "this is ning testing",
            originalResponse:
              "This is testing. If you need assistance with customer support-related questions, please let me know.",
          },
          {
            _id: "6808959698df9db058acae66",
            vectorIds: [],
            testGround: "6808957f98df9db058acadb4",
            created: "2025-04-23T07:24:02.859Z",
            adminFeedback: "thumbDown",
            userInput: "",
            originalResponse:
              "I'm here to assist you with customer support-related questions. If you need help with a specific issue or inquiry, please let me know.",
          },
          {
            _id: "6808958b98df9db058acae15",
            vectorIds: [],
            testGround: "6808957f98df9db058acadb4",
            created: "2025-04-23T07:23:52.169Z",
            adminFeedback: "thumbDown",
            userInput: "you bad bad",
            originalResponse:
              "This question is best handled by a human agent. Do you want to connect to a human agent?",
          },
          {
            _id: "6808958298df9db058acade4",
            vectorIds: [],
            testGround: "6808957f98df9db058acadb4",
            created: "2025-04-23T07:23:46.288Z",
            improvedResponse: null,
            adminFeedback: "thumbDown",
            adminFeedbackBy: {
              _id: "675664b9bdf1562c97acecc2",
              address: "0x2443B2e5953E09710496ac4ec69309aAD6060E46",
              name: "KY",
              entity: "653893232bd756be9bc2c452",
              role: "65c2082a8527f55d9f013bdf",
              created: "2024-12-09T03:32:09.070Z",
              __v: 0,
              latestLogin: "2025-06-04T07:05:16.319Z",
              email: "kyyao@metacrm.inc",
              telegram: "",
            },
            adminFeedbackCreated: "2025-04-28T06:23:12.117Z",
            userInput: "General",
            originalResponse:
              "Got it! Could you share a bit more detail so I can assist you better?",
          },
          {
            _id: "68088abd98df9db058ac5418",
            vectorIds: ["msg_68088abd98df9db058ac5418_chunk_0"],
            ticket: "68088ab398df9db058ac539e",
            created: "2025-04-23T06:37:49.687Z",
            userFeedback: "thumbUp",
            adminFeedback: "thumbDown",
            improvedResponse: "dhghf",
            userFeedbackCreated: "2025-04-28T05:02:24.623Z",
            userInput: "you bad bad",
            originalResponse:
              "This question is best handled by a human agent. Do you want to connect to a human agent?",
          },
          {
            _id: "68088a5a98df9db058ac4f67",
            vectorIds: [],
            ticket: "68088a5298df9db058ac4efd",
            created: "2025-04-23T06:36:10.763Z",
            userFeedback: "thumbUp",
            adminFeedback: "thumbUp",
            improvedResponse: null,
            userInput: "you bad bad",
            originalResponse:
              "This question is best handled by a human agent. Do you want to connect to a human agent?",
          },
          {
            _id: "68088a4998df9db058ac4e4c",
            vectorIds: ["msg_68088a4998df9db058ac4e4c_chunk_0"],
            ticket: "680889c398df9db058ac48de",
            created: "2025-04-23T06:35:53.083Z",
            adminFeedback: "thumbDown",
            improvedResponse: "hello",
            userInput: "you bad bad",
            originalResponse:
              "This question is best handled by a human agent. Do you want to connect to a human agent?",
          },
          {
            _id: "680889d198df9db058ac4982",
            vectorIds: ["msg_680889d198df9db058ac4982_chunk_0"],
            ticket: "680889c398df9db058ac48de",
            created: "2025-04-23T06:33:53.407Z",
            userFeedback: "thumbUp",
            adminFeedback: "thumbDown",
            improvedResponse: "i bad bad",
            userInput: "you bad bad",
            originalResponse:
              "This question is best handled by a human agent. Do you want to connect to a human agent?",
          },
        ],
        pagination: {
          totalCount: 24,
          page: 1,
          limit: 20,
          totalPages: 2,
        },
      })
    );
  }
);

const getKnowledgeBase = rest.get(
  `${apiUrl}/api/knowledgeBase/:entityName`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        _id: "67ec11459dbe1905dd5c2222",
        status: "completed",
        resourcesCount: 10,
        processedResourcesCount: 10,
        entity: "653893232bd756be9bc2c452",
        name: "standard Knowledge Base",
        description: "Migrated from AiConfig for standard",
        pineconeIndex: "metacrm-pc-index-dev-1",
        pineconeNamespace: "653893232bd756be9bc2c452",
        lastProcessedAt: "2025-05-14T08:13:20.275Z",
        createdAt: "2025-04-01T16:16:05.992Z",
        updatedAt: "2025-05-14T08:13:20.275Z",
        __v: 0,
        processingError: null,
        resources: [
          {
            _id: "681457aec9caf9f45a713752",
            status: "completed",
            retryCount: 1,
            vectorIds: [],
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "https://beraborrow.gitbook.io/docs",
            description: "",
            sourceType: "Gitbook",
            sourceUrl: "https://beraborrow.gitbook.io/docs",
            createdAt: "2025-05-02T05:27:10.304Z",
            updatedAt: "2025-05-14T08:13:20.086Z",
            __v: 2,
            lastProcessedAt: "2025-05-14T08:13:20.085Z",
            processingError: null,
          },
          {
            _id: "6801cf2ed0ce384eebad125c",
            status: "completed",
            retryCount: 1,
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "https://www.apple.com/tw/macbook-air/specs/",
            description: "",
            sourceType: "Website",
            sourceUrl: "https://www.apple.com/tw/macbook-air/specs/",
            createdAt: "2025-04-18T04:03:58.976Z",
            updatedAt: "2025-05-14T08:13:20.045Z",
            __v: 1,
            lastProcessedAt: "2025-05-14T08:13:20.045Z",
            processingError: null,
            vectorIds: [],
          },
          {
            _id: "6801c794d0ce384eebaca95c",
            status: "completed",
            retryCount: 1,
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "Raccoon+AI+FAQ+CSV+Pancakeswap - Raccoon+AI+FAQ+CSV+Pancakeswap.pdf",
            description: "",
            sourceType: "PDF",
            sourceUrl:
              "https://storage.googleapis.com/metacrm-upload-dev/knowledgeBase/Raccoon+AI+FAQ+CSV+Pancakeswap-Raccoon+AI+FAQ+CSV+Pancakeswap-373eeb28-4c77-45f6-ba43-6b2007650213-1744947090.pdf",
            fileName:
              "Raccoon%2BAI%2BFAQ%2BCSV%2BPancakeswap%20-%20Raccoon%2BAI%2BFAQ%2BCSV%2BPancakeswap.pdf",
            fileSize: 112415,
            createdAt: "2025-04-18T03:31:32.614Z",
            updatedAt: "2025-05-14T08:13:20.003Z",
            __v: 1,
            lastProcessedAt: "2025-05-14T08:13:20.003Z",
            processingError: null,
            vectorIds: [],
          },
          {
            _id: "6801c782d0ce384eebaca8e5",
            status: "completed",
            retryCount: 1,
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "https://metacrm.gitbook.io/metacrm",
            description: "",
            sourceType: "Gitbook",
            sourceUrl: "https://metacrm.gitbook.io/metacrm",
            createdAt: "2025-04-18T03:31:14.246Z",
            updatedAt: "2025-05-14T08:13:19.786Z",
            __v: 3,
            lastProcessedAt: "2025-05-14T08:13:19.785Z",
            processingError: null,
            vectorIds: [],
          },
          {
            _id: "67f74a7fbdf47dec33af4079",
            status: "completed",
            retryCount: 1,
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "sample (1).pdf",
            description: "",
            sourceType: "PDF",
            sourceUrl:
              "https://storage.googleapis.com/metacrm-upload-dev/knowledgeBase/sample(1)-da406cec-847d-429e-af70-7f0cb87f12f1-1744259711.pdf",
            fileName: "sample%20(1).pdf",
            fileSize: 18810,
            createdAt: "2025-04-10T04:35:11.930Z",
            updatedAt: "2025-05-14T08:13:19.743Z",
            __v: 1,
            lastProcessedAt: "2025-05-14T08:13:19.742Z",
            processingError: null,
            vectorIds: [
              "res_67f74a7fbdf47dec33af4079_chunk_0",
              "res_67f74a7fbdf47dec33af4079_chunk_1",
              "res_67f74a7fbdf47dec33af4079_chunk_2",
              "res_67f74a7fbdf47dec33af4079_chunk_3",
            ],
          },
          {
            _id: "67f74a05bdf47dec33af3dd3",
            status: "completed",
            retryCount: 1,
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "9ca25c72-4cb9-4d4a-853e-7d2ed20f466d_使用_AI_Support_知識庫提升回應效率.pdf",
            description: "",
            sourceType: "PDF",
            sourceUrl:
              "https://storage.googleapis.com/metacrm-upload-dev/knowledgeBase/9ca25c72-4cb9-4d4a-853e-7d2ed20f466d_使用_AI_Support_知識庫提升回應效率-29edce6f-d715-4df9-8375-003f75dcf1b0-1744259588.pdf",
            fileName:
              "9ca25c72-4cb9-4d4a-853e-7d2ed20f466d_%C3%A4%C2%BD%C2%BF%C3%A7%C2%94%C2%A8_AI_Support_%C3%A7%C2%9F%C2%A5%C3%A8%C2%AD%C2%98%C3%A5%C2%BA%C2%AB%C3%A6%C2%8F%C2%90%C3%A5%C2%8D%C2%87%C3%A5%C2%9B%C2%9E%C3%A6%C2%87%C2%89%C3%A6%C2%95%C2%88%C3%A7%C2%8E%C2%87.pdf",
            fileSize: 542485,
            createdAt: "2025-04-10T04:33:09.325Z",
            updatedAt: "2025-05-14T08:13:19.702Z",
            __v: 1,
            lastProcessedAt: "2025-05-14T08:13:19.702Z",
            processingError: null,
            vectorIds: [
              "res_67f74a05bdf47dec33af3dd3_chunk_0",
              "res_67f74a05bdf47dec33af3dd3_chunk_1",
              "res_67f74a05bdf47dec33af3dd3_chunk_2",
            ],
          },
          {
            _id: "67f6146b84ee0d76d2c313a7",
            status: "completed",
            retryCount: 1,
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "知識庫訓練文案.pdf",
            description: "",
            sourceType: "PDF",
            sourceUrl:
              "https://storage.googleapis.com/metacrm-upload-dev/knowledgeBase/知識庫訓練文案-88ace357-a56b-4ed3-acad-d953fb9d89e9-1744180330.pdf",
            fileName:
              "%C3%A7%C2%9F%C2%A5%C3%A8%C2%AD%C2%98%C3%A5%C2%BA%C2%AB%C3%A8%C2%A8%C2%93%C3%A7%C2%B7%C2%B4%C3%A6%C2%96%C2%87%C3%A6%C2%A1%C2%88.pdf",
            fileSize: 202385,
            createdAt: "2025-04-09T06:32:11.390Z",
            updatedAt: "2025-05-14T08:13:19.660Z",
            __v: 1,
            lastProcessedAt: "2025-05-14T08:13:19.660Z",
            processingError: null,
            vectorIds: [
              "res_67f6146b84ee0d76d2c313a7_chunk_0",
              "res_67f6146b84ee0d76d2c313a7_chunk_1",
              "res_67f6146b84ee0d76d2c313a7_chunk_2",
            ],
          },
          {
            _id: "67f4d58384ee0d76d2bab8ca",
            status: "completed",
            retryCount: 1,
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "https://metacrm.gitbook.io/metacrm",
            description: "",
            sourceType: "Gitbook",
            sourceUrl: "https://metacrm.gitbook.io/metacrm",
            createdAt: "2025-04-08T07:51:31.941Z",
            updatedAt: "2025-05-14T08:13:19.472Z",
            __v: 3,
            lastProcessedAt: "2025-05-14T08:13:19.472Z",
            processingError: null,
            vectorIds: [],
          },
          {
            _id: "67f4bb3884ee0d76d2b9fb5c",
            status: "completed",
            retryCount: 1,
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "知識庫訓練文案.pdf",
            description: "",
            sourceType: "PDF",
            sourceUrl:
              "https://storage.googleapis.com/metacrm-upload-dev/knowledgeBase/知識庫訓練文案-0bf4f347-8707-4eb8-a6ac-d8a629ad115f-1744091959.pdf",
            fileName:
              "%C3%A7%C2%9F%C2%A5%C3%A8%C2%AD%C2%98%C3%A5%C2%BA%C2%AB%C3%A8%C2%A8%C2%93%C3%A7%C2%B7%C2%B4%C3%A6%C2%96%C2%87%C3%A6%C2%A1%C2%88.pdf",
            fileSize: 202385,
            createdAt: "2025-04-08T05:59:20.765Z",
            updatedAt: "2025-05-14T08:13:19.432Z",
            __v: 1,
            lastProcessedAt: "2025-05-14T08:13:19.431Z",
            processingError: null,
            vectorIds: [
              "res_67f4bb3884ee0d76d2b9fb5c_chunk_0",
              "res_67f4bb3884ee0d76d2b9fb5c_chunk_1",
              "res_67f4bb3884ee0d76d2b9fb5c_chunk_2",
            ],
          },
          {
            _id: "67ec1e38617b35c46202c716",
            status: "completed",
            retryCount: 1,
            knowledgeBase: "67ec11459dbe1905dd5c2222",
            entity: "653893232bd756be9bc2c452",
            name: "Macro",
            description: "",
            sourceType: "Macro",
            createdAt: "2025-04-01T17:11:20.558Z",
            updatedAt: "2025-05-14T08:13:19.389Z",
            __v: 3,
            lastProcessedAt: "2025-05-14T08:13:19.388Z",
            processingError: null,
            vectorIds: [],
          },
        ],
        resourceStats: {
          total: 10,
          completed: 10,
          failed: 0,
          pending: 0,
          processing: 0,
        },
      })
    );
  }
);
const postMessages = rest.post(
  `${apiUrl}/api/trainingArea/:entityName/messages`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        adminFeedback: "thumbUp",
      })
    );
  }
);

export const adam = [
  getGreeting,
  getResponse,
  getAiSupport,
  startTestGroundChat,
  getMessages,
  getKnowledgeBase,
  postMessages,
];
